<template>
  <div class="commit">
    <ul>
      <li>倒计时截止日期根据世界卫生组织公布的中国人平均寿命计算 (https://www.who.int/countries/chn/zh/)</li>
      <li>每一行代表一个十年,例如90s代表1990年至1999年,倒计时的起始日期按照1990年1月1日计算. 结果是以1990年为基准的平均寿命</li>
      <li>设计倒计时的目的即希望所有人珍惜现在,活在当下.热爱你所热爱的,珍惜你所珍惜的,让你的每一天更有意义</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Commit'
}
</script>
<style lang="scss" scoped>
.commit {
  margin-top: 100px;
  border-top: 1px solid rgb(226, 226, 226);
  border-bottom: 1px solid rgb(226, 226, 226);
  color: rgb(172, 172, 172);;

  ul {
    display: flex;
    flex-direction: column;
    padding-left: 25px;

    li {
      list-style: circle;
      padding: 10px 0;
      font-size: .7rem;
      text-align: left;
    }
  }
}
</style>